var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84897 1.5L7.34726 3.07574L9.19793 3.5L7.34726 3.92426L6.84897 5.5L6.35067 3.92426L4.5 3.5L6.35067 3.07574L6.84897 1.5Z",
    fill: "#1E212C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22648 5.5L3.80485 7.46967L5.95296 8L3.80485 8.53033L3.22648 10.5L2.6481 8.53033L0.5 8L2.6481 7.46967L3.22648 5.5Z",
    fill: "#1E212C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4L12.3789 9.12114L17.5 10.5L12.3789 11.8789L11 17L9.62114 11.8789L4.5 10.5L9.62114 9.12114L11 4Z",
    fill: "#1E212C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.d6e6a6eeeef3d9063eee5bbdecb8c4a3.svg";
export { ForwardRef as ReactComponent };